type WorkTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

/** A task's stage and measured outcome are different signals. */
export function getWorkspaceWorkPresentation(status: string, outcome?: string | null) {
  const stages: Record<string, { label: string; tone: WorkTone }> = {
    open: { label: 'Ready to start', tone: 'neutral' },
    regression_candidate: { label: 'Needs investigation', tone: 'warning' },
    claimed: { label: 'Assigned', tone: 'info' },
    in_progress: { label: 'In progress', tone: 'info' },
    submitted: { label: 'Awaiting review', tone: 'warning' },
    measuring: { label: 'Measuring impact', tone: 'info' },
    verified: { label: 'Verification complete', tone: 'neutral' },
    closed: { label: 'Completed', tone: 'neutral' },
    dismissed: { label: 'Dismissed', tone: 'neutral' },
  };
  const presentation = stages[status] || { label: 'Recent work', tone: 'neutral' as WorkTone };
  // Historical verification must not overwrite the stage of work that has reopened.
  if (status !== 'verified' && status !== 'closed') return presentation;
  if (outcome === 'helped') return { label: 'Impact verified', tone: 'success' as WorkTone };
  if (outcome === 'regressed' || outcome === 'regression_candidate') {
    return { label: 'Regression detected', tone: 'danger' as WorkTone };
  }
  if (outcome === 'no_movement')
    return { label: 'No measured change', tone: 'neutral' as WorkTone };
  return presentation;
}
